export const usPostalCodeValidation = '^\\d{5}(-\\d{4})?$';
